import React from "react";
import DOMPurify from "dompurify";

interface RichTextRendererProps {
  content?: string | null;
  className?: string;
  fallback?: React.ReactNode;
}

/** Stub: render HTML content for preview. */
export const RichTextRenderer: React.FC<RichTextRendererProps> = ({
  content,
  className = "",
  fallback,
}) => {
  if (!content) return <>{fallback ?? null}</>;
  const safeHtml = DOMPurify.sanitize(content, {
    USE_PROFILES: { html: true },
  });
  return (
    <div
      className={`prose prose-sm max-w-none dark:prose-invert ${className}`}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
};

interface ProgramAboutRendererProps {
  content?: string | null;
  className?: string;
  fallbackText?: string;
}

export const ProgramAboutRenderer: React.FC<ProgramAboutRendererProps> = ({
  content,
  fallbackText,
  className,
}) => (
  <RichTextRenderer
    content={content || fallbackText}
    className={className}
  />
);

export default RichTextRenderer;
